//import angular from 'angular';
const moduleName = 'app.mobile';
export default moduleName;
angular.module(moduleName, []);
